<template>
  <div class="teach-resource-build">
    <div class="teach-resource-build-top">
        <div class="title">教研资源建设</div>
        <img class="title-bg" :src="require('@/assets/images/sydataboard/title-bg.png')" alt="">
    </div>
    <div class="teach-resource-build-box">
        <div class="teach-resource-build-left">
            <div class="build-top">
                <div class="tips">
                    <div class="color-bg"></div>
                    引用教研资源top5
                </div>
                <div class="resource-box">
                    <div class="resource-left">
                        <div class="box">
                            <div class="resource-number">9856</div>
                            <div class="resource-tips">较上周 ↑</div>
                        </div>
                        <div class="name">备课资源建设数</div>
                        <img :src="require('@/assets/images/bk-bg.png')" alt="">
                    </div>
                    <div class="resource-right">
                        <div class="box">
                            <div class="resource-number">6945</div>
                            <div class="resource-tips">较上周 ↑</div>
                        </div>
                        <div class="name">备课资源引用数</div>
                        <img :src="require('@/assets/images/yy-bg.png')" alt="">
                    </div>
                </div>
            </div>
            <div class="build-bottom">
                <div class="tips">
                    <div class="color-bg"></div>
                    引用教研资源top5
                </div>
                <div class="build-bottom-list">
                    <div class="build-bottom-item" v-for="item in courseList" :key="item.id">
                        <div class="resource-background"></div>
                        <div class="number resource-number">{{ item.number }}</div>
                        <!-- <count-up
                            class="infor-card-count user-created-count"
                            :id-name="`code_${item.name}`"
                            :end-val="item.number"
                            color="#27CDE6"
                            countSize="24px"
                            :countWeight="700"
                            :isConvert="1"
                            style="height:100%;"
                        >
                        </count-up> -->
                        <div class="resource-name">
                            {{ item.name }}
                        </div>
                        <div class="number-tips">较上周 ↑</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="teach-resource-build-right">
            <div class="tips">
                <div class="color-bg"></div>
                引用教研资源top5
            </div>
            <div class="resource-list">
                <div class="resource-item" v-for="item in resourceList" :key="item.id">
                    <div class="resource-info">
                        <img class="resource-icon" :src="item.icon" alt="">
                        <div class="type-name">{{ item.typeName }}</div>
                        <div class="title">{{ item.title }}</div>
                    </div>
                    <div class="teacher-name">
                        {{ item.teacherName }}老师分享
                    </div>
                </div>
            </div>
        </div>
    </div>
    <img class="top-left" :src="require('@/assets/images/sydataboard/top-left.png')" alt="">
    <img class="top-right" :src="require('@/assets/images/sydataboard/top-right.png')" alt="">
    <img class="left-bottom" :src="require('@/assets/images/sydataboard/left-bottom.png')" alt="">
    <img class="right-bottom" :src="require('@/assets/images/sydataboard/right-bottom.png')" alt="">
  </div>
</template>
<script>
import CountUp from "@/components/countUp.vue";
export default {
  name: 'teach-resource-build',
  data() {
    return {
        resourceList:[
            {
                title:"《望庐山瀑布》背景音乐.mp3",
                typeName:'课例',
                teacherName:"赵艳",
                icon:require('@/assets/images/hhxy.png'),
                id:1
            },
            {
                title:"课堂小知识",
                typeName:'微课',
                teacherName:"赵艳",
                icon:require('@/assets/images/hhxy.png'),
                id:2
            },
            {
                title:"第五章第一节第一课时硫及其氧化物",
                typeName:'课件',
                teacherName:"戴文静",
                icon:require('@/assets/images/hhxy.png'),
                id:3
            },
            {
                title:"Unit 1 第三课时 教案",
                typeName:'教案',
                teacherName:"许香婷",
                icon:require('@/assets/images/hhxy.png'),
                id:4
            },
            {
                title:"生物学与文学 借动物以言志【安徽】",
                typeName:'导学案',
                teacherName:"林子书",
                icon:require('@/assets/images/hhxy.png'),
                id:5
            }
        ],
        courseList:[
            {
                id:'1',
                name:"听评课资源建设数",
                number:584
            },
            {
                id:'2',
                name:"听评课资源引用数",
                number:1053
            },
            {
                id:'3',
                name:"分享校本资源数",
                number:10254
            },
        ]
    }
  },
  methods: {

  },
  mounted(){

  }
}
</script>
<style lang='scss' scoped>
.teach-resource-build{
    width: 100%;
    height: 350px;
    padding: 0 15px;
    border: 1px solid #053882;
    position: relative;
    margin-bottom: 20px;
    // background: rgba(6,17,52,0.8);
    .teach-resource-build-top{
        position: relative;
        text-align: center;
        margin-bottom: 15px;
        .title{
            display: inline-block;
            padding: 9px 22px 8px 17px;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #D0E7FE;
            line-height: 20px;
            position: relative;
            z-index: 2;
        }
        .more{
            display: inline-block;
            position: absolute;
            top: 0px;
            right: 0px;
            height: 100%;
            line-height: 44px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #359AFF;
            cursor: pointer;
        }
        .title-bg{
            width: auto;
            height: 100%;
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
        }
    }
    .teach-resource-build-box{
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: calc(100% - 55px);
        .teach-resource-build-left,
        .teach-resource-build-right{
            width: 50%;
            height: 100%;
            .tips{
                display: flex;
                align-items: center;
                justify-content: flex-start;
                font-size: 14px;
                font-family: Adobe Heiti Std;
                font-weight: normal;
                color: #27CDE6;
                .color-bg{
                    width: 14px;
                    height: 14px;
                    background: linear-gradient(90deg, #09132A, #0CBCC2);
                    margin-right: 5px;
                }
            }
        }
        .teach-resource-build-left{
            .build-top{
                height: 45%;
                .resource-box{
                    margin: 30px auto 20px;
                    display: flex;
                    align-items: center;
                    .resource-left,
                    .resource-right{
                        padding-left: 75px;
                        position: relative;
                        .box{
                            display: flex;
                            align-items: flex-end;
                            justify-content: flex-start;
                            margin-bottom: 5px;
                            position: relative;
                            z-index: 2;
                            .resource-number{
                                font-size: 30px;
                                font-family: Bahnschrift;
                                font-weight: 400;
                                color: #C3D2F8;
                                line-height: 30px;
                                margin-right: 5px;
                            }
                            .resource-tips{
                                font-size: 14px;
                                font-family: Source Han Sans CN;
                                font-weight: 400;
                                color: #2EB087;
                            }
                        }
                        .name{
                            font-size: 14px;
                            font-family: Microsoft YaHei;
                            font-weight: 400;
                            color: rgba(223, 232, 255, 0.63);
                            position: relative;
                            z-index: 2;
                        }
                        img{
                            position: absolute;
                            bottom: -10px;
                            left: 0;
                            width: 100%;
                        }
                    }
                }
            }
            .build-bottom{
                height: 55%;
                .build-bottom-list{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    .build-bottom-item{
                        display: flex;
                        flex-direction: column;
                        width: 190px;
                        height: 135px;
                        position: relative;
                        // background: url("../../../assets/images/sydataboard/bg2.png") no-repeat;
                        // background-size: 100% 100%;
                        .resource-background{
                            position: absolute;
                            top:28px;
                            bottom: 0;
                            width: 100%;
                            height: 70px;
                            left: 0;
                            background: url("../../../assets/images/sydataboard/bg2.png") no-repeat;
                            background-size: 100% 100%;
                        }
                        .resource-number{
                            width: 100%;
                            height: 80px;
                            display: flex;
                            justify-content: center;
                            font-size: 24px;
                            font-family: Adobe Heiti Std;
                            font-weight: normal;
                            color: #27CDE6;
                            // background: url("../../../assets/images/sydataboard/bg2.png") no-repeat;
                            // background-size: 100% 100%;
                        }
                        .resource-name{
                            margin-top: 10px;
                            font-size: 14px;
                            font-family: Microsoft YaHei;
                            font-weight: 400;
                            color: #7ABFDB;
                        }
                        .number-tips{
                            font-size: 14px;
                            font-family: Source Han Sans CN;
                            font-weight: 400;
                            color: #7ABFDB;
                        }
                    }
                }
            }
        }
        .resource-list{
            .resource-item{
                display: flex;
                align-items: center;
                justify-content:space-between ;
                width: 100%;
                height: 55px;
                border-bottom: 1px solid #3D4772;
                .resource-info{
                    display: flex;
                    align-items: center;
                    width: calc(100% - 100px);
                    .resource-icon{
                        display: block;
                        width:26px;
                        height: 26px;
                        margin-right: 10px;
                    }
                    .type-name{
                        display: inline-block;
                        padding: 3px 5px;
                        margin-right: 7px;
                        font-size: 12px;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        color: #4479FF;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        border: 1px solid #23448A;
                        border-radius: 2px;
                    }
                    .title{
                        font-size: 16px;
                        font-family: Microsoft YaHei;
                        font-weight: bold;
                        color: #A0B5EA;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                }
                .teacher-name{
                    height: 13px;
                    font-size: 12px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #6EA0D3;
                    width: 100px;
                    // margin-right: 0;
                    text-align: right;
                }
            }
            .resource-item:last-child(){
                border-bottom: 1px solid transparent;
            }
        }
    }
    .top-left{
          position: absolute;
          top: 0;
          left: 0;
          width: 14px;
          height: 14px;
      }
      .top-right{
          position: absolute;
          top: 0;
          right: 0;
          width: 14px;
          height: 14px;
      }
      .left-bottom{
          position: absolute;
          bottom: 0;
          left: 0;
          width: 14px;
          height: 14px;
      }
      .right-bottom{
          position: absolute;
          bottom: 0;
          right: 0;
          width: 14px;
          height: 14px;
      }
}
</style>